module.exports = __webpack_public_path__ + "static/media/9x12no1.af7a7542.jpg";